import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { SUPERGET, SUPERPOST } from "../../Services/AxiosService";
import { CustomStringify } from "../../Helpers/CustomStringify";

// GET BARCODE PRINT SETTING

export const fetchBarcodePrintSetting = createAsyncThunk(
    "BarcodePrintSetting/fetchBarcodePrintSetting",
    async (_, { getState, rejectWithValue }) => {
        try {
            const cmpdetail = getState().CompanyDetail?.cmpdetail;
            const result = await SUPERGET(`/barcodeSetting/${cmpdetail?.key}`);
            console.log({ result })
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message);
        }
    }
);

// POST BARCODE PRINT SETTING

export const saveBarcodePrintSetting = createAsyncThunk(
    "BarcodePrintSetting/saveBarcodePrintSetting",
    async (data, { rejectWithValue, getState }) => {
        const cmpdetail = getState().CompanyDetail?.cmpdetail;
        try {
            const result = await SUPERPOST(`/barcodeSetting/${cmpdetail?.key}`, data);
            return result;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message);
        }
    }
);

const BarcodePrintSettingSlice = createSlice({
    name: "BarcodePrintSetting",

    initialState: {
        BarPrintSetting: {},
        status: "idle",
        error: null,

        postStatus: "idle",
        postError: null,
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
            // GET
            .addCase(fetchBarcodePrintSetting.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })

            .addCase(fetchBarcodePrintSetting.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.BarPrintSetting = action?.payload?.data || {};
            })

            .addCase(fetchBarcodePrintSetting.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            // POST
            .addCase(saveBarcodePrintSetting.pending, (state) => {
                state.postStatus = "loading";
                state.postError = null;
            })

            .addCase(saveBarcodePrintSetting.fulfilled, (state, action) => {
                state.postStatus = "succeeded";
                // If API returns updated data,
                // update cmpdetail as well.
                if (action?.payload?.data) {
                    state.BarPrintSetting = {
                        ...action?.payload?.data,
                    };
                }
            })
            .addCase(saveBarcodePrintSetting.rejected, (state, action) => {
                state.postStatus = "failed";
                state.postError = action.payload;
            });
    },
});

export default BarcodePrintSettingSlice.reducer;